export enum ButtonTypeEnum {
    Default = 0,
    Dropdown = 1,
    CheckBoxSelected =2,
}